import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Collapse, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { SearchResult } from '../../../../types';
import { useLayoutContext } from '../../useLayoutContext';
import { Search, SearchIconWrapper, StyledInputBase } from './styled';
import { useNavigate } from 'react-router-dom';

export const SearchInput = () => {
  const { searchOptions, searchResults } = useLayoutContext();
  const navigate = useNavigate();
  const [value, setValue] = React.useState<SearchResult | null>(null);
  const [open, setOpen] = useState(false);
  const visible = !!searchOptions?.visible;

  const onRenderOptions = useCallback((
    props: React.HTMLAttributes<HTMLLIElement> & { key: string },
    option: SearchResult,
  ) => {
    if (searchOptions.renderOption) {
      return searchOptions.renderOption(props, option);
    } else { // default render
      return (
        <li id={option.id} {...props}>
          <Typography>{option.name}</Typography>
        </li>
      );
    }
  }, [searchOptions]);

  return (
    <Collapse
      orientation="horizontal" in={visible}
      sx={{
        width: '100%',
        '& .MuiCollapse-wrapperInner': (props) => ({
          [props.breakpoints.up('lg')]: {
            width: '100%',
          },
        }),
      }}
    >
      <Search visible={visible}>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <Autocomplete<SearchResult>
          id="main-search-input"
          sx={{
            '& .MuiAutocomplete-inputRoot': {
              paddingLeft: 4,
            },
          }}
          filterOptions={(x) => x}
          getOptionKey={(option) => option.id}
          autoComplete
          includeInputInList
          filterSelectedOptions
          value={value}
          clearOnEscape
          open={open}
          onChange={(event: React.SyntheticEvent, newValue: SearchResult | null) => {
            setValue(newValue);
            if (newValue) {
              navigate(`#${newValue.id}`);
            }
          }}
          onInputChange={(_, newInputValue) => {
            searchOptions.onSearch?.(newInputValue);
          }}
          onOpen={() => {
            setOpen(true);
            searchOptions?.onSearch?.('');
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          renderOption={onRenderOptions}
          options={searchResults}
          handleHomeEndKeys
          renderInput={({ inputProps, InputProps, InputLabelProps, ...rest }) => (
            <StyledInputBase
              {...rest}
              ref={InputProps.ref}
              id="search-input"
              placeholder={searchOptions?.placeholder}
              inputProps={{
                ...inputProps,
              }}
            />
          )}
        />
      </Search>
    </Collapse>
  );
};
